import { Reveal } from "../components/Reveal";

const SCHRITTE = [
  {
    titel: "Zielgruppe eingrenzen",
    text: "Wir definieren mit Ihnen die Entscheider, die Ihren Umsatz bestimmen, und filtern sie im Sales Navigator. Am Ende steht eine Liste mit Namen, nicht eine Zielgruppenbeschreibung."
  },
  {
    titel: "Profil und Positionierung",
    text: "Wir machen Ihr LinkedIn-Profil zu einem Profil, auf das ein Geschäftsführer gerne antwortet. Dazu Content, der Ihre Expertise bei genau dieser Zielgruppe sichtbar macht."
  },
  {
    titel: "Persönliche Ansprache",
    text: "Wir sprechen Ihre Zielgruppe in Ihrem Namen an, persönlich und in kleiner Zahl. Kein Massenversand. Tonalität und Vorlagen stimmen wir einmal mit Ihnen ab, danach läuft die Ansprache ohne Ihr Zutun."
  },
  {
    titel: "Termine in Ihrem Kalender",
    text: "Interessierte Entscheider landen als qualifizierte Entscheidergespräche bei Ihnen. Geplant mit 4–5 pro Monat."
  }
];

export default function Arbeitsweise() {
  return (
    <section className="bg-white py-20 sm:py-28 lg:py-32">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <Reveal>
          <div className="flex items-center gap-4">
            <span className="h-px w-10 bg-navy/40" />
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-textgrau">So arbeiten wir</p>
          </div>
          <h2
            className="mt-6 max-w-3xl text-2xl font-medium leading-snug tracking-[-0.01em] text-textdunkel sm:text-3xl lg:text-4xl"
            data-testid="arbeitsweise-ueberschrift"
          >
            Sie führen die Gespräche. Alles davor übernehmen wir.
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
          {SCHRITTE.map((s, i) => (
            <Reveal key={s.titel} delay={i * 0.06}>
              <div className="h-full border-t border-navy/15 pt-7" data-testid={`arbeitsweise-schritt-${i + 1}`}>
                <span className="text-5xl font-light tracking-[-0.02em] text-gruen">0{i + 1}</span>
                <h3 className="mt-5 text-base font-semibold text-textdunkel">{s.titel}</h3>
                <p className="mt-3 text-sm leading-[1.8] text-textgrau">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <p className="mt-16 max-w-3xl border-t border-navy/10 pt-8 text-base font-medium leading-[1.85] text-textdunkel" data-testid="arbeitsweise-aufwand">
            Ihr Aufwand: ein Onboarding-Monat mit vier Terminen, danach 45 Minuten im Monat zur Steuerung. Und die
            Gespräche selbst.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
